<script lang="ts">
	import { reducedMotion } from '$internal/stores/clientPreferences';
</script>

{#if $reducedMotion}
	<slot name="reduce" />
{:else}
	<slot name="no-preference" />
{/if}
